// Auth-aware client for the backend function. Attaches the LabOS Firebase ID
// token as a bearer. In production the base is relative ('') — Firebase Hosting
// rewrites /api/** to the function; override with VITE_FUNCTION_URL for local
// testing against a deployed backend.

import { auth } from './firebase';

const BASE = (import.meta.env.VITE_FUNCTION_URL as string | undefined) ?? '';

async function idToken(): Promise<string> {
  const user = auth.currentUser;
  if (!user) throw new Error('Not signed in');
  return user.getIdToken();
}

export async function apiFetch<T>(path: string, opts: RequestInit = {}): Promise<T> {
  const token = await idToken();
  const res = await fetch(`${BASE}/api${path}`, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(opts.headers ?? {}),
    },
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`API ${res.status}: ${text || res.statusText}`);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}

// Same-origin media URL with the ID token in the query (for <video>/<audio>,
// which can't set an Authorization header). Served by the streaming endpoint.
export async function mediaProxyUrl(path: string): Promise<string> {
  const token = await idToken();
  return `${BASE}/api${path}?token=${encodeURIComponent(token)}`;
}
